import type { AppRouteModule } from '/@/router/types';
import { LAYOUT } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PageEnum } from '/@/enums/pageEnum';

const dashboard: AppRouteModule = {
  path: '/market',
  name: 'Market',
  component: LAYOUT,
  redirect: '/market/index',
  meta: {
    orderNo: 1,
    icon: 'menus-home|svg',
    title: t('routes.dashboard.market'),
    hideChildrenInMenu: true,
    hideBreadcrumb: false,
    hideHeader: false,
    hideMenu: true,
  },
  children: [
    {
      path: 'index',
      name: 'MarketPage',
      component: () => import('/@/views/home/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.dashboard.overview'),
        hideBreadcrumb: true,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'packageAssembly',
      name: 'PackageAssembly',
      component: () => import('/@/views/market/packageAssembly/index.vue'),
      meta: {
        // affix: true,
        title: t('maap.portfolio_calculation'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'packageAssemblyDetail/:seqId?/:groupId?',
      name: 'PackageAssemblyDetail',
      component: () => import('/@/views/market/packageAssembly/Detail.vue'),
      meta: {
        // affix: true,
        title: t('maap.portfolio_calculation'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'droDetail/:droCode/:listed?',
      name: 'droDetail',
      component: () => import('/@/views/market/dro/index.vue'),
      meta: {
        // affix: true,
        title: t('routes.mcex.droDetail'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'allMarket',
      name: 'AllMarketPage',
      component: () => import('/@/views/home/overview/AllMarket.vue'),
      meta: {
        // affix: true,
        title: t('maap.marketwide'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },

    {
      path: 'allDro/:brandId?',
      props: true,
      name: 'allDroPage',
      component: () => import('/@/views/market/allDro/index.vue'),
      meta: {
        // affix: true,
        title: t('maap.allDro'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
    {
      path: 'allBrand',
      name: 'allBrandPage',
      component: () => import('/@/views/market/allBrand/index.vue'),
      meta: {
        // affix: true,
        title: t('maap.allBrand'),
        hideBreadcrumb: false,
        currentActiveMenu: PageEnum.MARKET_INDEX_Logged,
      },
    },
  ],
};

export default dashboard;
